import NavNestedItemsList from './NavNestedItemsList';
import { NavSubLinkProps } from './types';
import { HEADER_NAV_ID_PREFIX } from './utils';

interface NavNestedSubMenuProps {
  subLink: NavSubLinkProps;
}

const NavNestedSubMenu = ({ subLink }: NavNestedSubMenuProps) => {
  // Pinned to the scroll container's padding-box edges, so this panel supplies its own inset.
  return (
    <div className="p-6 max-sm:pb-20">
      <NavNestedItemsList subLink={subLink} idPrefix={HEADER_NAV_ID_PREFIX} />
    </div>
  );
};

export default NavNestedSubMenu;
